import * as Msal from "msal";
import {AuthenticationParameters, AuthResponse, Configuration, UserAgentApplication} from "msal";
import store from '../store'
import BimsHttpService from "@/services/BimsHttpService";
import {Configuration as BIMSConfiguration} from "@/Configuration"

class AuthenticationService {

    private config: Configuration = {
        auth: {
            clientId: BIMSConfiguration.OpenIdConnect.ClientId,
            authority: "https://login.microsoftonline.com/" + BIMSConfiguration.OpenIdConnect.TenantId,
            redirectUri: BIMSConfiguration.OpenIdConnect.RedirectUrl,
            navigateToLoginRequestUrl: true,
            postLogoutRedirectUri: "https://my.tti.tamu.edu"
        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
    };

    private msalApp: UserAgentApplication = new Msal.UserAgentApplication(this.config);

    constructor() {
        this.msalApp.handleRedirectCallback((authResponse: AuthResponse) => {
            if (authResponse && authResponse.accessToken) {
                BimsHttpService.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.accessToken;

                // login the user to BIMS
                store.dispatch('login', authResponse);

                return;
            }
        }, (authErr: any) => {
            console.error("AuthError: ", authErr);
        });
    }

    /**
     * @description Logs the user in through a redirect based on the config
     */
    public async login() {
        const loginScopes = {
            scopes: ["openid", "profile", "email", BIMSConfiguration.OpenIdConnect.RequestScope]
        };

        const user = this.msalApp.getAccount();

        if (!user) {
            this.msalApp.loginRedirect(loginScopes);
        } else {
            await this.getApiAccessToken();
        }
    }

    /**
     * @description Returns the API access token for the given scopes
     */
    public async getApiAccessToken(): Promise<AuthResponse | void> {

        const redirectScopes: AuthenticationParameters = {
            scopes: ["openid", "profile", "email",BIMSConfiguration.OpenIdConnect.RequestScope],
        };

        const silentTokenScopes: AuthenticationParameters = {
            scopes: [BIMSConfiguration.OpenIdConnect.RequestScope],
        };

        const user = this.msalApp.getAccount();

        if (!user) {
            await this.login();
        }

        // First attempt to get the token silently
        return this.msalApp.acquireTokenSilent(silentTokenScopes).then((authResponse: AuthResponse) => {
            BimsHttpService.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.accessToken;

            // login the user to BIMS
            store.dispatch('login', authResponse).then(() => {
                return authResponse;
            });
        }).catch((error) => {
            // Attempt to get the token through a redirect
            this.msalApp.acquireTokenRedirect(redirectScopes)
        });
    }

    public logout(): void{
        this.msalApp.logout()
    }
}

export default new AuthenticationService()
